import { render, staticRenderFns } from "./AppGrid.vue?vue&type=template&id=045e6b8e&scoped=true&"
import script from "./AppGrid.vue?vue&type=script&lang=js&"
export * from "./AppGrid.vue?vue&type=script&lang=js&"
import style0 from "./AppGrid.vue?vue&type=style&index=0&id=045e6b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e6b8e",
  null
  
)

export default component.exports